import { TOUR_TRANSLATIONS } from "../translations"

export const getChangesSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="changes-filters"]',
            title: t.changesFilters.title,
            content: t.changesFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="changes-table"]',
            title: t.changesTable.title,
            content: t.changesTable.content,
        },
        {
            target: '[data-tour="changes-create-report"]',
            title: t.changesCreateReport.title,
            content: t.changesCreateReport.content,
        },
        {
            target: '.MuiDialog-paper, .MuiDrawer-paper',
            title: t.changesEvolution.title,
            content: t.changesEvolution.content,
            placement: 'center',
            disableScrolling: true,
            data: { triggerClick: 'changes-table', closeOnLeave: true },
        },
    ]
}
